import { c as _c } from "react/compiler-runtime";
import { CheckBoxSwitcher } from '@systemeio/ui';
import { ActivateCampaignStepContentProps } from 'modules/campaigns/campaign-steps/components/activate-campaign-step/activate-campaign-step-content-without-button';
import { ActionType } from 'modules/campaigns/campaign-steps/components/activate-campaign-step/store';
import React, { useEffect, useState } from 'react';
import WeekdaysPicker from 'shared/components/date-picker/weekdaysPicker';
import { INTITIAL_SELECTED_WEEKDAYS_STATE } from 'shared/components/date-picker/weekdaysPicker/constants';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface WeekdaysSelectorProps extends Pick<ActivateCampaignStepContentProps, 'dispatch'> {
  weekdays: ActivateCampaignStepContentProps['state']['chosenWeekdays'];
  error?: string;
}
export function WeekdaysSelector(t0) {
  const $ = _c(21);
  const {
    weekdays,
    dispatch,
    error
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  let t1;
  let t2;
  if ($[0] !== weekdays) {
    t1 = () => {
      const isChanged = Object.values(weekdays).includes(false);
      if (!isChanged) {
        return;
      }
      setOpened(true);
    };
    t2 = [weekdays];
    $[0] = weekdays;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== t) {
    t3 = t("dashboard.campaign_step.activate.excluded_weekdays.label");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== dispatch) {
    t4 = value => {
      setOpened(value);
      if (!value) {
        dispatch({
          type: ActionType.set_chosen_weekdays,
          payload: INTITIAL_SELECTED_WEEKDAYS_STATE
        });
      }
    };
    $[5] = dispatch;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== opened || $[8] !== t3 || $[9] !== t4) {
    t5 = <CheckBoxSwitcher label={t3} selected={opened} onChange={t4} />;
    $[7] = opened;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== dispatch || $[12] !== opened || $[13] !== weekdays) {
    t6 = opened && <WeekdaysPicker selectedWeekdays={weekdays} onChange={value_0 => dispatch({
      type: ActionType.set_chosen_weekdays,
      payload: value_0
    })} />;
    $[11] = dispatch;
    $[12] = opened;
    $[13] = weekdays;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== error) {
    t7 = <FieldErrorAndDescription error={error} />;
    $[15] = error;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
    t8 = <div className="flex flex-col gap-2">{t5}{t6}{t7}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}